import { ISelfSignupRepository } from "../../adapters/driven/repositories/selfSignupRepository";

export type ISelfSignupService = ReturnType<typeof SelfSignupServiceImplFactory>;

export const SelfSignupServiceImplFactory = ({
  selfSignupRepository,
}: {
  selfSignupRepository: ISelfSignupRepository;
}) => {
  const registerPendingUser = async (payload: {
    first_name?: string;
    last_name?: string;
    phone?: string;
  }) => {
    return selfSignupRepository.selfSignup(payload);
  };

  const checkActivationStatus = async () => {
    return selfSignupRepository.checkActivationStatus();
  };

  return {
    registerPendingUser,
    checkActivationStatus,
  };
};
